<ng-container *ngIf="characteristics$ | async as characteristics">
  <nz-table
    #characteristicsTableReference
    [nzData]="characteristics"
    [nzLoading]="loading"
    nzSize="small"
    class="em-area em-no-table-row-hover"
  >
    <thead>
      <tr>
        <th>Characteristic</th>
        <th>MIC</th>
        <th>Text Inspection</th>
        <th>Target value</th>
        <th>Lower limit</th>
        <th>Upper limit</th>
        <th>1. lower limit</th>
        <th>1. upper limit</th>
        <th>UOM</th>
        <th>Master inspection characteristic</th>
        <th>Sampling plan</th>
        <th>Long text</th>
      </tr>
    </thead>
    <tbody>
      <ng-container
        *ngFor="let characteristic of characteristicsTableReference.data; trackBy: trackByRef"
      >
        <tr>
          <td>
            {{ characteristic.characteristic }}
            <!-- <em-warning-icon
              *ngIf="failedValidations$ | async | applyPure: hasFailedValidation:characteristic"
            ></em-warning-icon> -->
          </td>
          <td>
            <i
              nz-icon
              [nzType]="
                characteristic.refMasterInspectionCharacteristic ? 'check-circle' : 'close-circle'
              "
              nzTheme="twotone"
              [nzTwotoneColor]="
                characteristic.refMasterInspectionCharacteristic ? '#52c41a' : 'red'
              "
            ></i>
          </td>
          <td>{{ characteristic.shortText }}</td>
          <td>{{ characteristic.targetValue | number: '1.5-5' }}</td>
          <td>{{ characteristic.lowerLimit | number: '1.5-5' }}</td>
          <td>{{ characteristic.upperLimit | number: '1.5-5' }}</td>
          <td>{{ characteristic.firstLowerLimit | number: '1.5-5' }}</td>
          <td>{{ characteristic.firstUpperLimit | number: '1.5-5' }}</td>
          <td>{{ characteristic.unitOfMeasure }}</td>
          <td>{{ characteristic.masterInspectionCharacteristics }}</td>
          <td>{{ characteristic.samplingProcedure }}</td>
          <td>
            <button
              *ngIf="characteristic.longTextExists"
              (click)="showLongText(characteristic)"
              nz-button
              nzType="link"
            >
              <i nz-icon nzType="file-text" nzTheme="twotone" nzTwotoneColor="5914fa"></i>
            </button>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>
</ng-container>
